{
  "name": "textbook-player-front",
  "version": "3.0.2",
  "description": "Frontend dla Multipodręczników,",
  "license": "UNLICENSED",
  "private": true,
  "authors": [
    {
      "name": "Konrad Albrecht",
      "email": "kalbrechtgwo@gmail.com",
      "url": "https://github.com/kdshop"
    },
    {
      "name": "Dawid Fulmes",
      "email": "dfulmes@gmail.com",
      "url": "https://www.gitlab.gwo.pl/dfulmes"
    }
  ],
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "lint": "ng lint",
    "start2": "concurrently -n PLAYER,LOCALTUNNEL -c bgRed.bold,bgGreen.bold.yellow \"yarn start --disable-host-check\" \"yarn lt\"",
    "testy": "concurrently \"yarn start --disable-host-check\" \"yarn cy\"",
    "lt": "npx localtunnel --port 4200",
    "test": "ng test",
    "e2e": "ng e2e",
    "cy": "yarn run cypress open",
    "build:dev": "ng build -c development",
    "build:prod": "ng build -c production",
    "build:staging": "ng build -c staging",
    "build:preview:dev": "ng build -c preview-development",
    "build:preview:prod": "ng build -c preview-production",
    "build:preview:staging": "ng build -c preview-staging",
    "build:watch": "yarn build:dev --watch",
    "build:android": "node builder/builder build-android",
    "build:android:prod": "yarn build:android production",
    "build:android:staging": "yarn build:android staging",
    "build:android:dev": "yarn build:android dev",
    "build:android:watch": "node builder/builder build-android-watch",
    "build:ios": "node builder/builder build-ios staging",
    "build:ios:prod": "node builder/builder build-ios prod",
    "prepare": "husky install"
  },
  "dependencies": {
    "@angular/animations": "^19.2.15",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.15",
    "@angular/compiler": "^19.2.15",
    "@angular/core": "^19.2.15",
    "@angular/forms": "^19.2.15",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.15",
    "@angular/platform-browser-dynamic": "^19.2.15",
    "@angular/router": "^19.2.15",
    "@capacitor-community/device": "^7.0.0",
    "@capacitor-community/keep-awake": "^7.1.0",
    "@capacitor/android": "^7.0.0",
    "@capacitor/angular": "^2.0.3",
    "@capacitor/app": "^7.0.0",
    "@capacitor/app-launcher": "^7.0.0",
    "@capacitor/core": "^7.0.0",
    "@capacitor/device": "^7.0.0",
    "@capacitor/filesystem": "^7.0.0",
    "@capacitor/ios": "^7.0.0",
    "@capacitor/keyboard": "^7.0.0",
    "@capacitor/network": "^7.0.0",
    "@juggle/resize-observer": "^3.3.1",
    "@ngrx/effects": "^19.2.1",
    "@ngrx/operators": "^19.2.1",
    "@ngrx/router-store": "^19.2.1",
    "@ngrx/schematics": "^19.2.1",
    "@ngrx/store": "^19.2.1",
    "@ngrx/store-devtools": "^19.2.1",
    "@panzoom/panzoom": "^4.6.0",
    "@sweetalert2/ngx-sweetalert2": "^14.0.0",
    "@yarnpkg/parsers": "2.1.0",
    "capacitor-blob-writer": "^1.0.1",
    "capacitor-resources": "^2.0.5",
    "concurrently": "^6.2.0",
    "cypress": "^14.0.0",
    "dayjs": "^1.10.7",
    "faker": "^5.5.3",
    "hammerjs": "^2.0.8",
    "http-errors": "^2.0.0",
    "http-method-enum": "^1.0.0",
    "http-server": "^13.0.2",
    "mobile-detect": "^1.4.5",
    "ngx-cookie-service": "^12.0.3",
    "ngx-pagination": "^6.0.2",
    "panzoom": "^9.4.3",
    "rxjs": "^7.0.1",
    "screenfull": "^5.1.0",
    "sweetalert2": "^11.1.5",
    "ts-enums": "^0.0.6",
    "tslib": "^2.2.0",
    "uuid": "^9.0.0",
    "video.js": "^7.13.3",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.16",
    "@angular-eslint/builder": "^19.0.0",
    "@angular-eslint/eslint-plugin": "^19.0.0",
    "@angular-eslint/eslint-plugin-template": "^19.0.0",
    "@angular-eslint/schematics": "^19.0.0",
    "@angular-eslint/template-parser": "^19.0.0",
    "@angular/cli": "^19.2.16",
    "@angular/compiler-cli": "^19.2.15",
    "@capacitor/cli": "^7.0.0",
    "@nrwl/workspace": "19.8.14",
    "@types/faker": "^5.5.5",
    "@types/hammerjs": "^2.0.39",
    "@types/http-errors": "^1.8.2",
    "@types/jasmine": "^3.7.4",
    "@types/lodash": "4.14.182",
    "@types/node": "^15.3.0",
    "@types/uuid": "^8.3.4",
    "@types/video.js": "^7.3.29",
    "@typescript-eslint/eslint-plugin": "4.28.2",
    "@typescript-eslint/parser": "4.28.2",
    "codelyzer": "^6.0.2",
    "eslint": "^7.26.0",
    "eslint-config-prettier": "^8.3.0",
    "eslint-plugin-prettier": "^4.0.0",
    "husky": "^7.0.4",
    "jasmine-core": "^3.7.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-coverage": "^2.0.3",
    "karma-jasmine": "^4.0.1",
    "karma-jasmine-html-reporter": "^1.6.0",
    "ng-packagr": "^19.2.2",
    "nx": "19.8.14",
    "pdfjs-dist": "2.7.570",
    "prettier": "^2.3.0",
    "protractor": "^7.0.0",
    "ts-node": "^9.1.1",
    "tslint": "^6.1.3",
    "typescript": "~5.8.3",
    "worker-loader": "^3.0.7"
  }
}
